 import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";

const DynamicVideoCarousel = ({ videos, heading, showNavigation = true }) => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  const nextVideo = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  const prevVideo = () => {
    setCurrentVideoIndex((prevIndex) =>
      prevIndex === 0 ? videos.length - 1 : prevIndex - 1
    );
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => nextVideo(),
    onSwipedRight: () => prevVideo(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true, // allows swipe with mouse too
  });

  return (
    <div className="w-full relative flex flex-col items-center bg-white py-1 md:py-4">
      {heading && (
        <h2 className="text-center text-2xl md:text-3xl font-bold text-[#8b2218] mb-6 md:mb-8">
          {heading}
        </h2>
      )}

      <div className="relative w-full flex flex-col items-center">
        <div
          {...swipeHandlers}
          className="relative w-full mx-auto md:w-2/3 lg:w-1/2 aspect-video overflow-hidden rounded-lg shadow-lg"
        >
          {/* Video iframe */}
          <iframe
            key={currentVideoIndex}
            className="absolute top-0 left-0 w-full h-full"
            src={`${videos[currentVideoIndex]}?autoplay=1&mute=1&loop=1&playlist=${videos[currentVideoIndex].split("/").pop()}&modestbranding=1&rel=0&showinfo=0`}
            title={`Video ${currentVideoIndex + 1}`}
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>

          {/* Navigation Arrows on Video Frame */}
          {showNavigation && videos.length > 1 && (
            <>
              <button
                onClick={prevVideo}
                className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-20 hover:bg-opacity-50 text-white p-2 md:p-3 rounded-full transition-all"
              >
                &#10094;
              </button>
              <button
                onClick={nextVideo}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-20 hover:bg-opacity-50 text-white p-2 md:p-3 rounded-full transition-all"
              >
                &#10095;
              </button>
            </>
          )}
        </div>

        {/* Optional count indicator */}
        {videos.length > 1 && (
          <div className="mt-3 text-sm text-gray-600">
            {currentVideoIndex + 1} of {videos.length}
          </div>
        )}
      </div>
    </div>
  );
};

export default DynamicVideoCarousel;
